import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEvent, deleteEvent, updateEvent, fetchEvents } from "../../../Slices/events.slice";
import { IoIosCloseCircle } from "react-icons/io";

import { EventsMenubar, TravelMenubar } from "components/layout/MenuBar";
import Nav from "components/layout/Nav";
import { DataTable } from "components/shared/table";
import { CreateLocation } from "components/shared/buttons";
import { AddEvent } from "components/forms/forms";

const Components = {
    eventTable: "eventTabel",
    recentEvents: "recentEvent",
    Drafts: "Drafts",
};

const UpcomingEvents = () => {
    const [activeComponent, setActiveComponent] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const dispatch = useDispatch();
    const { status, error, events } = useSelector((state) => state.events);
    const [addLocationClicked, setAddLocationClicked] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        desc: "",
        contact: "",
        category: "upcoming events",
        poster: { img: "", alt: "" },
        aboutORG: {
            oraganization: "",
            memberSince: "",
            totalTrips: "",
            socialLinks: { insta: "", fb: "" },
        },
        features: {
            days: "",
            approxDistance: "",
            startingDate: "",
            startsFrom: "",
            altitude: "",
            grade: "",
        },
        amountToPay: "",
    });

    const closePopup = () => {
        setShowForm(false);
    };

    const defaultFormData = {
        title: "",
        desc: "",
        contact: "",
        category: "upcoming events",
        poster: { img: "", alt: "" },
        aboutORG: {
            oraganization: "",
            memberSince: "",
            totalTrips: "",
            socialLinks: { insta: "", fb: "" },
        },
        features: {
            days: "",
            approxDistance: "",
            startingDate: "",
            startsFrom: "",
            altitude: "",
            grade: "",
        },
        amountToPay: "",
    };

    // Use it for reset
    const handleAddEventClick = () => {
        setFormData(defaultFormData);
        setShowForm(true);
    };

    const handleDelete = (id) => {
        dispatch(deleteEvent(id));
        dispatch(fetchEvents());
    };
    const handleAddEventSubmit = (eventData) => {
        if (eventData?._id) {
            dispatch(updateEvent({ id: eventData._id, updatedData: eventData }))
                .then((response) => {
                    if (response.type.endsWith("fulfilled")) {
                        setShowForm(false); // Close the form after updating
                        dispatch(fetchEvents()); // Refresh the events list
                    } else {
                        console.error("Failed to update event:", response.payload || response.error);
                    }
                });
        } else {
            dispatch(addEvent(eventData))
                .then((response) => {
                    if (response.type.endsWith("fulfilled")) {
                        setShowForm(false); // Close the form after adding
                        dispatch(fetchEvents()); // Refresh the events list
                    } else {
                        console.error("Failed to add event:", response.payload || response.error);
                    }
                });
        }
    };


    const handleEditClick = (event) => {
        setFormData(event);
        setShowForm(true);
    };





    useEffect(() => {
        if (!events.length) {
            dispatch(fetchEvents());
        }
    }, [dispatch, events.length]);

    const renderComponent = () => {
        switch (activeComponent) {
            case Components.eventTable:
                return (
                    <>
                        <CreateLocation
                            buttonText={"Add Event"}
                            formComponent={AddEvent}
                            showForm={showForm}
                            setShowForm={handleAddEventClick}
                        />
                        {showForm && (
                            <div className="popup overviewPopup">
                                <div className="row" style={{ columnGap: "30px", justifyContent: "space-between" }}>
                                    <i className="warning">
                                        For creating an event, please fill the event details below.
                                    </i>
                                    <IoIosCloseCircle className="close" onClick={closePopup} />
                                </div>
                                <AddEvent
                                    formData={formData}
                                    setFormData={setFormData}
                                    onSubmit={handleAddEventSubmit}
                                    isEditing={!!formData._id}
                                />
                            </div>
                        )}
                        <DataTable
                            locations={events}
                            showViewPage={true}
                            deleteConfirmation={handleDelete}
                            editClick={handleEditClick}
                        />
                    </>
                );
            default:
                return <div>Select a component from the menu.</div>;
        }
    };

    return (
        <>
            <Nav />
            <div className="row">
                <EventsMenubar setActiveComponent={setActiveComponent} />
                <main style={{ width: "calc(100vw - 240px)", backgroundColor: "#D0D5DD" }}>
                    {status === "loading" && <p>Loading Events...</p>}
                    {error && <p style={{ color: "red" }}>Error: {error}</p>}
                    {renderComponent()}
                </main>
            </div>
        </>
    );
};

export default UpcomingEvents;
